module.exports = __webpack_public_path__ + "img/photo-0.dc7644d9.webp";